var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgGrilledMeat = function SvgGrilledMeat(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.13 9.844c-.802-.802-1.577-1.748-2.087-2.762a4.931 4.931 0 1 0-5.868 6.926c.874.27 1.683.814 2.33 1.462a3.978 3.978 0 0 0 5.625-5.626Z",
    fill: "#FF5454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.427 10.534A1.745 1.745 0 1 0 5.96 8.066a1.745 1.745 0 0 0 2.468 2.468Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.427 10.534A1.745 1.745 0 1 0 5.96 8.066a1.745 1.745 0 0 0 2.468 2.468Z",
    stroke: "#FF5454",
    strokeWidth: 0.643
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.427 10.534A1.745 1.745 0 1 0 5.96 8.066a1.745 1.745 0 0 0 2.468 2.468Z",
    stroke: "#000",
    strokeOpacity: 0.18,
    strokeWidth: 0.643
  })));
};
export default SvgGrilledMeat;